import script from "./WebhookDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhookDelete.vue?vue&type=script&setup=true&lang=js"

import "./WebhookDelete.vue?vue&type=style&index=0&id=32994f3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32994f3c"]])

export default __exports__